import React from 'react';
import { toast } from 'react-toastify';

// ── YouTube URL helpers ───────────────────────────────────────────────────────

const sanitiseYouTubeId = (value) => { const v = String(value ?? "").trim(); return /^[a-zA-Z0-9_-]{11}$/.test(v) ? v : ""; };

const getYouTubeIdFromUrl = (url) => {
    const raw = String(url ?? "").trim();
    if (!raw) return "";
    if (/^[a-zA-Z0-9_-]{11}$/.test(raw)) return raw;
    let u; try { u = new URL(raw); } catch { return ""; }
    const host = (u.hostname || "").replace(/^www\./, "").toLowerCase();
    const path = u.pathname || "";
    if (host === "youtu.be") return sanitiseYouTubeId(path.split("/").filter(Boolean)[0] || "");
    if (host === "youtube.com" || host === "m.youtube.com" || host === "music.youtube.com") {
        if (path === "/watch") return sanitiseYouTubeId(u.searchParams.get("v"));
        const parts = path.split("/").filter(Boolean);
        if (parts[0] === "embed" && parts[1]) return sanitiseYouTubeId(parts[1]);
        if (parts[0] === "shorts" && parts[1]) return sanitiseYouTubeId(parts[1]);
        if (parts[0] === "live" && parts[1]) return sanitiseYouTubeId(parts[1]);
        const v = u.searchParams.get("v"); if (v) return sanitiseYouTubeId(v);
    }
    return "";
};

// ── Component ─────────────────────────────────────────────────────────────────

const YouTubeBox = ({ youtubeUrlInput, setYoutubeUrlInput, youtubeVideoId, effectiveIsEditing, setCustomisationValue }) => {
    const onAddVideo = () => {
        const id = getYouTubeIdFromUrl(youtubeUrlInput);
        if (!id) { toast.warn("Could not find a valid YouTube video ID in that URL."); return; }
        setCustomisationValue("youtubeVideoId", id);
    };

    const clearVideo = () => { setYoutubeUrlInput(""); setCustomisationValue("youtubeVideoId", ""); };

    const embedBlock = (vid) => (
        <div className="relative w-full overflow-hidden border border-black/30 bg-black/5" style={{ paddingTop: "56.25%" }}>
            <iframe className="absolute inset-0 w-full h-full" src={`https://www.youtube-nocookie.com/embed/${vid}`} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen />
        </div>
    );

    return (
        <div className="w-full">
            {effectiveIsEditing ? (
                <>
                    <div className="flex items-center gap-2 px-3 py-2 border-b border-black/20 bg-black/5">
                        <input type="url" value={youtubeUrlInput} onChange={(e) => setYoutubeUrlInput(e.target.value)} placeholder="Paste a YouTube URL..." onPointerDown={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()} onClick={(e) => e.stopPropagation()} onKeyDownCapture={(e) => e.stopPropagation()} className="flex-1 min-w-0 px-2 py-1 text-xs border border-black/30 bg-offwhite text-coal rounded focus:outline-none" />
                        <button type="button" onClick={(e) => { e.stopPropagation(); onAddVideo(); }} onPointerDown={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()} onKeyDownCapture={(e) => e.stopPropagation()} className="px-2 py-1 text-xs border border-black/30 bg-offwhite text-coal rounded hover:bg-black/10 transition-colors">Add Video</button>
                        <button type="button" onClick={(e) => { e.stopPropagation(); clearVideo(); }} onPointerDown={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()} onKeyDownCapture={(e) => e.stopPropagation()} className="px-2 py-1 text-xs border border-black/30 bg-offwhite text-coal rounded hover:bg-black/10 transition-colors">Clear</button>
                    </div>
                    <div className="p-3">{youtubeVideoId ? embedBlock(youtubeVideoId) : <div className="text-coal/80 text-sm">There&apos;s nothing to see here!</div>}</div>
                </>
            ) : youtubeVideoId ? (
                <div className="p-3">{embedBlock(youtubeVideoId)}</div>
            ) : (
                <div className="p-3 text-coal/80 text-sm">There&apos;s nothing to see here!</div>
            )}
        </div>
    );
};

export default YouTubeBox;